import { DocumentParameters, Source } from 'api3';
import { Injectable, inject } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { type SourceDto } from './types';
import { TranslocoService } from '@jsverse/transloco';

@Injectable({
  providedIn: 'root',
})
export class SourcesService {
  translocoService = inject(TranslocoService);

  getDocumentLink(documentParameters: DocumentParameters, tabId: string, provider?: Source['provider']) {
    const stringParams: Record<string, string> = Object.fromEntries(Object.entries(documentParameters).map(([key, value]) => [key, String(value)]));

    if (provider) {
      stringParams['provider'] = provider;
    }

    stringParams['articleView'] = 'true';

    return {
      path: `/chat/${tabId}/`,
      params: stringParams,
    };
  }

  async getTypeName(source: SourceDto | undefined) {
    if (!source) return undefined;

    return firstValueFrom(this.translocoService.selectTranslate(`source.name.${source.provider}`));
  }

  async getCategoryName(source: SourceDto | undefined) {
    if (!source) return undefined;

    switch (source.provider) {
      case 'haynespro':
        const category = source.subject;
        return await firstValueFrom(this.translocoService.selectTranslate(`source.category.${category}`));
      case 'mercedes':
      case 'qiradb':
      case 'hgs':
      default:
        return undefined;
    }
  }
}
